import React, { useState } from "react";
import {
  Typography,
  Button,
  Box,
  Modal,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import AccessibleIconButton from "components/base/AccessibleIconButton";

const CopyPopup = ({
  copyConfirmPopup,
  setCopyConfirmPopup,
  collection,
  handleCopyCollection,
}) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleCopy = async () => {
    setLoading(true);
    try {
      const data = await handleCopyCollection(collection.collectionId);
      setCopyConfirmPopup(false);
      if (data?.newCollectionId) {
        navigate(`/collections/${data.newCollectionId}`);
      }
    } catch (error) {
      toast.error("Failed to copy collection");
    } finally {
      setLoading(false);
    }
  };

  const onClose = () => {
    setCopyConfirmPopup(false);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "100vw", sm: "50vw", md: "35vw" },
    bgcolor: "background.paper",
    boxShadow: 0,
    borderRadius: 2,
  };

  return (
    <Modal
      open={copyConfirmPopup}
      onClose={onClose}
      slotProps={{
        backdrop: {
          style: { backgroundColor: "rgba(0, 0, 0, 0.2)" },
        },
      }}
    >
      <Box sx={modalStyle}>
        <Box sx={{ p: 4 }}>
          <Typography
            variant="h4"
            component="div"
            color="#406da4"
            fontWeight="600"
          >
            Confirm Copy
          </Typography>
          <AccessibleIconButton
            title="Close"
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </AccessibleIconButton>

          <Typography variant="body1" mt={1}>
            Are you sure you want to make a copy of this collection? A
            duplicate, including all notes and works cited, will be added to
            your collections.
          </Typography>
        </Box>
        <Box
          sx={{
            backgroundColor: "secondary.main",
            display: "flex",
            justifyContent: "space-between",
            gap: 5,
            px: 5,
            py: 3,
            borderRadius: "0 0 20px 20px",
          }}
        >
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{ width: "45%" }}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleCopy}
            disabled={loading}
            sx={{
              width: "45%",
              display: "flex",
              gap: 1,
            }}
          >
            {loading && <CircularProgress size={20} />}
            Copy
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CopyPopup;
